export default __webpack_public_path__ + "assets/d74e3f1ef4f802ac3fadca469485c3f6.jpeg";